var exports = {
  "kL": "xa15a2ab7--f1775c--container",
  "ld": "xa15a2ab7--f1775c--items",
  "AS": "xa15a2ab7--f1775c--item",
  "Kk": "xa15a2ab7--f1775c--icon",
  "nn": "xa15a2ab7--f1775c--buttons-wrap",
};

module.exports = exports;
